import { BadgeCheck, CalendarClock } from "lucide-react";

const fmtDate = (iso) => {
  if (!iso) return "";
  const d = new Date(iso);
  return Number.isNaN(d.getTime()) ? iso.slice(0, 10) : d.toLocaleDateString(undefined, { year: "numeric", month: "long", day: "numeric" });
};

const daysLeft = (iso) => {
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return null;
  return Math.max(0, Math.ceil((d.getTime() - Date.now()) / 86400000));
};

const COPY = {
  subscription: { title: "Subscribed", sub: (s) => `Active until ${fmtDate(s.full_access_expires_at)}` },
  granted: { title: "Full access granted", sub: () => "Permanent access — no expiry" },
  free: { title: "Free course", sub: () => "Full access — no payment needed" },
  lifetime: { title: "Full access", sub: () => "No expiry" },
};

/** Replaces the Subscribe CTA once a course is fully unlocked. */
export function SubscriptionStatus({ state }) {
  const src = state?.full_access_source || "lifetime";
  const copy = COPY[src] || COPY.lifetime;
  const left = src === "subscription" && state.full_access_expires_at ? daysLeft(state.full_access_expires_at) : null;
  return (
    <div
      className="w-full rounded-md border border-emerald-300 bg-white/70 dark:bg-emerald-950/30 px-3 py-2 flex items-start gap-2"
      data-testid={`subscription-status-${state?.course_id}`}
    >
      <BadgeCheck className="w-5 h-5 text-emerald-600 shrink-0 mt-0.5" />
      <div className="min-w-0 text-sm">
        <div className="font-semibold text-emerald-800 dark:text-emerald-200" data-testid={`subscription-status-title-${state?.course_id}`}>{copy.title}</div>
        <div className="text-xs text-emerald-700 dark:text-emerald-300 flex items-center gap-1 flex-wrap" data-testid={`subscription-status-expiry-${state?.course_id}`}>
          {src === "subscription" && <CalendarClock className="w-3.5 h-3.5" />}
          {copy.sub(state)}
          {left !== null && <span className="font-semibold">· {left} day{left === 1 ? "" : "s"} left</span>}
        </div>
      </div>
    </div>
  );
}

export default SubscriptionStatus;
